// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { TextFieldProps } from "@conklin/MobiusOverrides/TextField/TextField";
import { createUserModalStyles } from "@conklin/Overrides/Widgets/UserList/CreateUserModal";
import { xScreen } from "@conklin/XDL/Utilities";
import translate from "@insite/client-framework/Translate";
import HelpCircle from "@insite/mobius/Icons/HelpCircle";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

createUserModalStyles.roleSelectHelpIcon = {
    src: HelpCircle,
    size: 16,
    css: css`
        margin-left: 5px;
        margin-right: 5px;
        cursor: pointer;
        vertical-align: middle;
    `,
};

createUserModalStyles.approverSelectTooltip = {};

createUserModalStyles.settingsHeadingGridItem = {
    width: 12,
    css: css`
        position: relative;
        padding-block: 14px;
        &&& {
            margin-bottom: 8px;
        }

        &:after {
            content: "";
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            width: calc(100% - 15px);
            height: 1px;
            background-color: ${getColor("common.border")};
            margin: 0 auto;
        }
    `,
};

createUserModalStyles.settingsHeadingText = {
    variant: "h5",
    css: css`
        margin-bottom: 0;
    `,
};

createUserModalStyles.userNameTextField = {
    placeholder: translate("Username"),
} as TextFieldProps;

createUserModalStyles.emailTextField = {
    placeholder: translate("Email"),
} as TextFieldProps;

createUserModalStyles.confirmEmailTextField = {
    placeholder: translate("Confirm Email"),
} as TextFieldProps;

createUserModalStyles.firstNameTextField = {
    placeholder: translate("First Name"),
} as TextFieldProps;

createUserModalStyles.lastNameTextField = {
    placeholder: translate("Last Name"),
} as TextFieldProps;

createUserModalStyles.buttonsGridItem = {
    css: css`
        justify-content: space-between;
        gap: 10px;
        padding-top: 14px;
        ${xScreen("lte", "sm")} {
            flex-direction: column-reverse;
        }
    `,
    width: 12,
};

createUserModalStyles.cancelButton = {
    variant: "secondary",
    css: css`
        ${xScreen("lte", "sm")} {
            width: 100%;
        }
    `,
};

createUserModalStyles.submitButton = {
    css: css`
        ${xScreen("lte", "sm")} {
            width: 100%;
        }
    `,
};

createUserModalStyles.userNameVisibleGridItem = { width: [12, 6, 6, 6, 6] };
createUserModalStyles.emailGridItem = { width: [12, 6, 6, 6, 6] };
createUserModalStyles.firstNameGridItem = { width: [12, 6, 6, 6, 6] };
createUserModalStyles.lastNameGridItem = { width: [12, 6, 6, 6, 6] };
createUserModalStyles.roleGridItem = { width: [12, 6, 6, 6, 6] };
createUserModalStyles.approverGridItem = { width: [12, 6, 6, 6, 6] };
